import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { ClaimTypes } from './types'

const fetchClaimTypes = async (treatmentTypeId: string) => {
  const response = await httpClientPrivate.get<ClaimTypes>(
    `${config.restUrl}/v1/backoffice/e-claim/claim-types`,
    {
      params: {
        treatmentTypeId,
      },
    },
  )

  return response.data
}

const useClaimTypes = (treatmentTypeId: string, options: any) => {
  const queryKey = ['useClaimTypes', treatmentTypeId]
  const queryFn = async () => fetchClaimTypes(treatmentTypeId)
  const queryResult = useQuery({ queryKey, queryFn, ...options })

  return { ...queryResult }
}

export { fetchClaimTypes, useClaimTypes }
